<template>
  <div class="container">
    <el-tabs v-model="activeTab" @tab-click="tabClick">
      <el-tab-pane label="下载中心" name="downloadCenter">
        <el-table :data="sharedFiles" height="650" border>
          <el-table-column prop="file_name" label="文件名">
          </el-table-column>
          <el-table-column prop="size" label="大小">
          </el-table-column>
          <el-table-column prop="upload_at" label="更新时间">
          </el-table-column>
          <el-table-column prop="creator" label="上传者">
          </el-table-column>
          <el-table-column label="操作" width="180">
            <template v-slot="scope">
              <div class="demoFiles-actions">
                <el-link size="small" type="primary" @click="downloadSharedFiles(scope.row.id)">下载</el-link>
                <!-- <el-link type="danger" onclick="alert('删除成功')">删除</el-link> -->
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import Nav from '../Global/Nav.vue'
export default {
  name: 'SharedFiles',
  components: {
    Nav
  },
  data() {
    return {
      activeTab: 'downloadCenter',
      sharedFiles: []
    }
  },
  mounted() {
    // if (!("Notification" in window)) {
    //   console.log("This browser does not support system notifications");
    // } else if (Notification.permission === "granted") {
    //   var notification = new Notification("Hello, World!");
    // } else if (Notification.permission !== "denied") {
    //   Notification.requestPermission().then(function (permission) {
    //     if (permission === "granted") {
    //       var notification = new Notification("Hello, World!");
    //     }
    //   });
    // }
    this.getSharedFiles();
  },
  methods: {
    tabClick() { },
    getSharedFiles() {
      this.$axios.get(`/center/shared_files/list`).then((response) => {
        if (response.data.code === 200) {
          this.sharedFiles = response.data.data
        }
      })
    },
    downloadSharedFiles(id) {
      window.location.href = this.$axios.defaults.baseURL + 'center/shared_files/download?id=' + id;
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/Modules/SharedFiles.vue